<template>
  <div :id="id" class="flex flex-col px-6 lg:px-20 xl:max-w-3/4 2xl:max-w-2/3 lg:mx-auto">
    <div class="flex flex-wrap lg:flex-nowrap lg:justify-end relative">
      <div class="lg:z-10 lg:flex-grow lg:absolute lg:top-12"
           :class="[sideClasses, sideWidth]">
        <slot name="side"></slot>
      </div>
      <div class="w-full px-8 py-8 lg:py-12 lg:flex lg:flex-col xl:py-16"
           :class="contentClasses"
           style="box-shadow: 0 3px 66px 0 rgba(100, 153, 214, 0.16);">
        <div :class="containerClasses">
          <h2 class="max-w-4/5 mb-8 lg:mb-10" :class="[inverted ? 'text-white' : 'text-dark-blue']">
            <slot name="title"></slot>
          </h2>
          <slot name="content"></slot>
        </div>

        <!--<div class="flex lg:w-1/2" v-if="cta">-->
        <!--  <div class="mt-6 lg:mt-12 w-full flex">-->
        <!--    <bubble-link :href="route('survey.start', $page.props.surveys[0].slug)" :type="{ 'inverted' : inverted }"-->
        <!--                 class="mx-auto">{{-->
        <!--        $trans('app.start')-->
        <!--      }}-->
        <!--    </bubble-link>-->
        <!--  </div>-->
        <!--</div>-->

        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import BubbleLink from "@/Components/BubbleLink"

export default {
  name: 'section-explanation',
  components: {BubbleLink},
  props: {
    reverse: {
      default: false
    },
    inverted: {
      default: false
    },
    id: {},
    cta: {
      default: true
    },
    fullW: {
      default: false
    },
    containerClasses: {
      default: "w-full md:w-7/12 lg:w-2/3"
    },
    sideWidth: {
      default: 'w-full lg:w-2/5 lg:max-w-sm'
    }
  },
  computed: {
    sideClasses() {
      return {
        '': this.reverse,
        'lg:left-0': !this.reverse
      }
    },
    contentClasses() {
      return {
        'bg-white': !this.inverted,
        'bg-dark-blue text-white': this.inverted,
        'lg:mr-40': this.reverse && !this.fullW,
        'lg:ml-40': !this.reverse && !this.fullW,
        'lg:items-end': !this.reverse
      }
    }
  }
}
</script>
